import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import docIcon from "../../images/icons/doc-big.png";
import dwgIcon from "../../images/icons/dwg-big.png";
import mpgIcon from "../../images/icons/mpg-big.png";
import pdfIcon from "../../images/icons/pdf-big.png";
import xlsIcon from "../../images/icons/xls-big.png";

import Document from "../../_shark_models/Document";

class DocumentManager extends Controller {
	constructor(name) {
		super(name);
	}

	delete (document) {
		if (!document) {
			document = Shark.get("editingDocument");
		}
		const rd = NousCore.api.createRequest({ item: document.export() });

		return NousCore.api.send("document/delete", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const documentList = Shark.get("documentList").filter(item => item.guid !== document.guid);
						Shark.set({documentList});
						documentManager.emit("documentDeleted");
						return {
							data: documentList,
							status: "ok"
						};
					}
					case 404:
						documentManager.emit("documentDeletionError");
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	delete2 (documents) {
		const rd = NousCore.api.createRequest({ items: documents.map(item => { return {guid: item.guid}; }) });

		return NousCore.api.send("document/delete", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	async getByGuidList2 (guidList) {
		let data = { item: { guidList: guidList } };
		const rd = NousCore.api.createRequest(data);
		const requestedAction = "get-by-guid-list";
	
		return NousCore.api.send(`document/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const documentList = Shark.getInstanceList(Document, data.items);

						return {
							data: documentList,
							requestedAction,
							status: "ok",
						};
					}
					case 404:
						return {
							data,
							requestedAction,
							status: "ok",
						};
				}
			}
		});
	}

	getIconFromExtension (extension) {
		let icon;
	
		switch (extension.toLowerCase()) {
			// case "jpg":
			// 	icon = this.fileURL.replace(".jpg", "_tmb.jpg");
			// 	break;
			case "pdf":
				icon = pdfIcon;
				break;
			case "doc":
			case "docx":
				icon = docIcon;
				break;
			case "dwg":
				icon = dwgIcon;
				break;
			case "mp4":
			case "mpg":
				icon = mpgIcon;
				break;
			case "xls":
			case "xlsx":
				icon = xlsIcon;
				break;
		}

		return icon;
	}

	async save2 (documentList) {
		let actions = new Set();

		documentList.forEach(document => {
			actions.add(document.guid === "" ? "insert" : "update");
		});

		if (actions.size > 1) {
			alert("Non posso preosuguire");
			return;
		}
		
		const rd = NousCore.api.createRequest({ items: documentList.map(document => document.export()) });
		const action = Array.from(actions)[0];

		return NousCore.api.send(`document/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						documentList.forEach((document, index) => {
							document.import(data.items[index]);
							document.clean();
						});

						return {
							data: documentList,
							requestedAction: action,
							status: "ok",
						};
					case 99:
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}
	
	setStatusByGuid (guid, status) {
		let data = { item: { guid, status } };
		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("document/set-status-by-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						// const currVisitDocumentList = Shark.getInstanceList("Document", data.items);
						// Shark.set("currVisitDocumentList", currVisitDocumentList);

						// documentManager.emit("listChanged");
						return {
							data,
							status: "ok"
						};
					case 99:
						// documentManager.emit("listGetError");
						return {
							data,
							status: "ko"
						};
				}
			}
		});
	}

	async upload (target) {
		return NousCore.api.uploadFiles(target, "document/upload")
		.then(function (jsonData) {
			const savedFiles = jsonData.payload.items;
			const newDocuments = [];

			savedFiles.forEach(savedFile => {
				switch (savedFile.rc) {
					case 1: {
						const fileType = savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1).toLowerCase();

						const newDocument = Shark.getInstance("Document", {
							fileSize: savedFile.size,
							fileType,
							fileURL: "/" + savedFile.filePath,
							// guid: newGuid,
							name: savedFile.name,
							status: 1,
							thumbnailURL: savedFile.thumbnailFilPath ? "/" + savedFile.thumbnailFilPath : (["jpg", "jpeg", "png"].indexOf(fileType) > -1 ? "/" + savedFile.filePath : ""),
						});

						newDocuments.push(newDocument);
						break;
					}
					case 95:
						break;
					default:
						alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
				}
			});

			return {
				data: {documents: newDocuments},
				status: "ok"
			};
		});
	}






	
	getByGuidList (guidList) {
		let data = { item: { guidList: guidList } };

		const rd = NousCore.api.createRequest(data);

		NousCore.api.send("document/get-by-guid-list", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const currVisitDocumentList = Shark.getInstanceList("Document", data.items);

						Shark.set("currVisitDocumentList", currVisitDocumentList);

						documentManager.emit("listChanged");
						break;
					case 404:
						documentManager.emit("listGetError");
						break;
				}
			}
		});
	}

	getList (parentFolder) {
		let data = { item: { folderGuid: "" } };

		if (parentFolder) {
			data.item.folderGuid = parentFolder.guid;
		}

		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("document/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const documentList = Shark.getInstanceList("Document", data.items);

						documentList.sort((a, b) => {
							if (a.name > b.name) {
								return 1;
							}
							else if (a.name < b.name) {
								return -1;
							}
						});

						Shark.set("documentList", documentList);

						documentManager.emit("listChanged");
						return {
							data: documentList,
							status: "ok"
						}
					case 404:
						documentManager.emit("listGetError");
						return {
							data: "",
							status: "ko"
						}
				}
			}
		});
	}
	//Dave: Probabilmente questo e quello sopra si possono smontare per avere una parte in comune
	getSystemList (parentFolder) {
		let data = { item: { folderGuid: "", role: "anyFilled" } };

		if (parentFolder) {
			data.item.folderGuid = parentFolder.guid;
		}

		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("document/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const documentList = Shark.getInstanceList("Document", data.items);

						documentList.sort((a, b) => {
							if (a.name > b.name) {
								return 1;
							}
							else if (a.name < b.name) {
								return -1;
							}
						});

						return {
							data: documentList,
							status: "ok"
						}
					case 404:
						return {
							data: "",
							status: "ko"
						}
				}
			}
		});
	}

	htmlToPdf (item) {
		let data = { item };
		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("document/html-to-pdf", rd)
		.then((data) => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction: "html-to-pdf",
							status: "ok",
						}
					case 404:
						return {
							data: null,
							requestedAction: "html-to-pdf",
							status: "ko",
						}

				}
			}
		});
	}

	save (document) {
		const rd = NousCore.api.createRequest({ item: document.export() });
		const action = document.guid === "" ? "insert" : "update";

		return NousCore.api.send(`document/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						document.import(data.items[0]);
						document.clean();

						documentManager.emit("saved");
						return {
							data: document,
							requestedAction: action,
							status: "ok",
						};
					case 99:
						documentManager.emit("documentSaveError");

						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	uploadDuplicate (path, name, type) {
		const rd = NousCore.api.createRequest({ item: { tempFile: path, originalName: name }});

		NousCore.api.send("document/confirm_temp_dupe_file", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:

					const editingDocument = Shark.get("editingDocument")
					if (type === "fileURL") {
						editingDocument.set("fileSize", data.items[0].size);
						editingDocument.set("fileType", data.items[0].type);
					}
					editingDocument.set(type, data.items[0].filePath);
					Shark.render();
					break;
					case 404:
					documentManager.emit("documentSaveError");
					break;
				}
			}
		});
	}

}

const documentManager = new DocumentManager("documentManager");

// Dave.Warn: Ma che è sta cosa???
documentManager.extractDocumentFolder = function (documentTree, documentList, documentMap, depth = 0) {
	if (!documentTree.subFolders) {
		documentTree = {
			documents: [],
			fullPath: "/",
			subFolders: {}
		}
	}

	for (var i = 0; i < documentList.length; i++) {
		const currDocument = documentList[i];
		let folderChar;

		if (currDocument.section.indexOf("\\") > -1) {
			folderChar = "\\";
		}
		else {
			folderChar = "/";
		}
		const pathParts = currDocument.section.split(folderChar);
		const fullPath = pathParts.filter((pathPart, index) => index <= depth).reduce((a, b) => a + folderChar + b, "");

		if (depth === 0) {
			if (!documentMap["/"].subFolders[fullPath]) {
				documentMap["/"].subFolders[fullPath.substr(1)] = {}
			}
		}

		if (!documentTree.subFolders[pathParts[depth]]) {
			documentTree.subFolders[pathParts[depth]] = {
				documents: documentList.filter(currDocument2 => {
					return folderChar + currDocument2.section === fullPath;
				}),
				fullPath: fullPath.replace(/\\/g, "/"),
				subFolders: {}
			};
			documentMap[documentTree.subFolders[pathParts[depth]].fullPath] = {
				documents: documentTree.subFolders[pathParts[depth]].documents,
				subFolders: documentTree.subFolders[pathParts[depth]].subFolders
			};
			const folderDocuments = documentList.filter(currDocument2 => {
				return folderChar + currDocument2.section.substr(0, fullPath.length - 1) === fullPath;
			});
			// documentManager.extractDocumentFolder({}, ["dd"], depth + 1);
			if (depth < pathParts.length - 1) {
				documentManager.extractDocumentFolder(documentTree.subFolders[pathParts[depth]], folderDocuments, documentMap, depth + 1);
			}
		}
		// else {
		// 	documentTree.subFolders[pathParts[depth]].documents.push(currDocument);
		// }
	}
	// });
	return documentTree;
};


Shark.registerController(documentManager);

export { documentManager };
